<template>
  <section class="section">
    <div class="container">
      <h1 class="title">{{ $translate('shapes') | capitalize }}</h1>
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <b-button
              v-if="permissions.canCreate"
              type="is-primary"
              icon-right="plus"
              @click="
                $router.push({
                  name: 'newShape',
                  params: { id: -1, module: module },
                })
              "
            ></b-button>
          </div>
        </div>
        <div class="level-right"></div>
      </div>
      <b-table
        :data="filteredData"
        :paginated="tableOptions.isPaginated"
        :narrowed="true"
        :per-page="tableOptions.perPage"
        :current-page.sync="tableOptions.currentPage"
        :pagination-simple="tableOptions.isPaginationSimple"
        :sort-icon="tableOptions.sortIcon"
        :sort-icon-size="tableOptions.sortIconSize"
        :loading="tableOptions.loading"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
        hoverable
      >
        <template slot-scope="props">
          <b-table-column field="commercial_name" :label="$translate('shape_name') | capitalize" sortable>
            {{ props.row.commercial_name }}
          </b-table-column>

          <b-table-column field="type" :label="$translate('fit_code') | capitalize" sortable>
            {{ props.row.fit_code }}
          </b-table-column>

          <b-table-column field="type" :label="$translate('size_range') | capitalize" sortable>
            {{ checkSizeRange(props.row) }}
          </b-table-column>

          <b-table-column field="type" :label="$translate('type') | capitalize" sortable>
            {{ $translate(props.row.type) | capitalize }}
          </b-table-column>

          <b-table-column :label="$translate('action') | capitalize">
            <a
              v-if="permissions.canEdit"
              @click="
                $router.push({
                  name: 'editShape',
                  params: { id: props.row.id, module: module },
                })
              "
            >
              <b-icon icon="pencil-outline"></b-icon>
            </a>
            <a
              v-if="permissions.canCreate"
              @click="
                $router.push({
                  name: 'newShape',
                  params: { module: module, idtocopy: props.row.id },
                })
              "
            >
              <b-icon icon="content-copy"></b-icon>
            </a>
            <a v-if="permissions.canDelete" @click="deleteOccurence(props.row.id)">
              <b-icon icon="delete-outline"></b-icon>
            </a>
          </b-table-column>
        </template>
      </b-table>
    </div>
  </section>
</template>

<script>
//import firebase from "firebase";
import mainMixin from '@/helpers/mixins/mainMixin'
import permissionMixin from '@/helpers/mixins/permissionMixin'

export default {
  name: 'Shapes',
  components: {},
  mixins: [mainMixin, permissionMixin],
  props: ['module'],
  data() {
    return {
      loading: true,
    }
  },
  mounted() {
    let permissionDenied = true
    switch (this.userInfo.type) {
      case 'A':
        permissionDenied = false
        this.permissions.canCreate = true
        this.permissions.canEdit = true
        this.permissions.canHide = true
        this.permissions.canDelete = true
        break
      case 'I':
        if (this.userInfo.level === 'S' || this.userInfo.level === '2') {
          this.permissions.canCreate = true
          this.permissions.canEdit = true
          this.permissions.canDelete = true
        }
        permissionDenied = false
        break
    }
    if (permissionDenied) this.$router.push('/forbidden')
    this.loadData()
  },
  methods: {
    deleteOccurence(idtoerase) {
      this.$buefy.dialog.confirm({
        title: this.$translate('attention'),
        message: this.$translate('shape_message_destroy'),
        cancelText: this.$translate('undo'),
        confirmText: this.$translate('shape_message_confirm'),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.$db
            .collection(this.$moduleConfiguration[this.module].shapes)
            .doc(idtoerase)
            .delete()
            .then(async () => {
              this.loadData()
              this.$buefy.notification.open({
                duration: 3000,
                message: this.$translate('success_delete'),
              })
            })
        },
      })
    },
    checkSizeRange(shape) {
      let filteredSizes = []
      for (const size of shape.sizes) {
        filteredSizes.push(Number(size.size))
      }
      const minSize = Math.min(...filteredSizes)
      const maxSize = Math.max(...filteredSizes)
      return `${minSize} - ${maxSize}`
    },

    loadData() {
      let newTableData = []
      this.$db
        .collection(this.$moduleConfiguration[this.module].shapes)
        .orderBy('commercial_name', 'asc')
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            let shape = doc.data()
            shape.id = doc.id

            newTableData.push(shape)
          })
          this.filteredData = newTableData
          this.tableOptions.loading = false
        })
    },
  },
}
</script>
